
function numberOnly() {
    let numbers = document.querySelectorAll('.number_only');

    Array.prototype.slice.call(numbers)
        .forEach(function (number) {
            number.addEventListener('keypress', function (event) {
                let keycode = event.which;
                if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
                    event.preventDefault();
                }
            });
        });
}

function excludeNumbers() {
    let inputs = document.querySelectorAll('.exclude_numbers');

    Array.prototype.slice.call(inputs)
        .forEach(function (input) {
            input.addEventListener('keypress', function (event) {
                let keycode = event.which;
                if ((keycode >= 48 && keycode <= 57)) {
                    event.preventDefault();
                }
            });
        });
}

export { numberOnly, excludeNumbers }